module.exports = __webpack_public_path__ + "img/5.6b7caf72.png";